module.exports = __webpack_public_path__ + "img/marker-icon.fd9ede09.png";